// | ------------------------------------------------------------------------
// | Main Navigation
// | ------------------------------------------------------------------------ 

import {
    Tab
  } from "bootstrap";

//? https://kingsora.github.io/OverlayScrollbars/
import { OverlayScrollbars } from "overlayscrollbars";

//? https://github.com/yowainwright/shave
import shave from "shave"; // Used in /components/ellipsis

import { smoother } from '../gsap/index'


// | ------------------------------------------------------------------------

// Hide overlay
var hideOverlay = function () {
    const overlay = document.querySelector(".overlay");
    overlay.classList.remove("show");
};

// Show overlay
var showOverlay = function () {
    const overlay = document.querySelector(".overlay");
    overlay.classList.add("show");
};

window.addEventListener("load", (event) => {
    // Set variables
    var body = document.querySelector("body");
    var navDropdown = document.querySelector(".nav-dropdown");
    var navButton = document.querySelector("#menu-btn");
    var windowWidth = document.body.clientWidth;

    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    const header = document.querySelector(".site-header");
    const smoothContent = document.getElementById("smooth-content");

    // Toggle menu
    var toggleMenu = function () {
        body.classList.toggle("menu-open");
        navButton.classList.toggle("show");
        document.documentElement.classList.toggle("no-scroll");
        navDropdown.classList.toggle("show");

        if (
            body.classList.contains("menu-open") ||
            body.classList.contains("modal-open")
        ) {
            showOverlay();
            navButton.ariaExpanded = "true";
            document.documentElement.style.overflow = "hidden";
            smoothContent.style.paddingRight = scrollbarWidth + "px";
            header.style.paddingRight = scrollbarWidth + "px";
            smoother.paused(true);
        } else {
            hideOverlay();
            navButton.ariaExpanded = "false";
            document.documentElement.style.overflow = "auto";
            smoothContent.style.paddingRight = "0px";
            header.style.paddingRight = "0px";
            smoother.paused(false);
        }
    };

    // Close Tabs
    function closeTabs() {
        // Close all tab panes
        var tabPanes = document.querySelectorAll(".main-nav-pane");
        tabPanes.forEach(function (tab) {
            tab.classList.remove("active");
            navDropdown.classList.add("empty");
        });
    }    

    if (navButton) {
        // Open/close menu using button
        navButton.addEventListener(
            "click",
            function (event) {
                event.stopPropagation();
                toggleMenu();
            },
            false
        );

        // Prevent menu closing when clicked
        navDropdown.addEventListener(
            "click",
            function (event) {
                event.stopPropagation();
            },
            false
        );

        // Close menu when clicking outside of it
        body.addEventListener(
            "click",
            function () {
                if (body.classList.contains("menu-open")) {
                    toggleMenu();
                }
            },
            false
        );

        // Close drawer if window is resized
        window.addEventListener("resize", function () {
            if (document.body.clientWidth !== windowWidth) {
                if (body.classList.contains("menu-open")) {
                    toggleMenu();
                }
            }
            windowWidth = document.body.clientWidth;
        });

        // Get tabs in menu to open on hover
        document.querySelectorAll(".main-nav-tabs a").forEach(function (navItem) {
            // Open relevant tab when mouse enters
            navItem.addEventListener("mouseenter", function () {
                var tabTrigger = new Tab(navItem);
                tabTrigger.show();
                navDropdown.classList.remove("empty");
            });

            // Close tab when mouse leaves
            navItem.addEventListener("mouseleave", function () {
                closeTabs();

                // Remove stuff from tab link
                navItem.classList.remove("active");
                navItem.setAttribute("aria-selected", "false");
            });

            // Click takes you to the relevant page
            navItem.addEventListener("click", function () {
                var navUrl = navItem.getAttribute("href");
                window.location.href = navUrl;
            });
        });

        document.querySelectorAll(".main-nav-pane").forEach(function (tabPane) {
            // Keep tab open when mouse enters
            tabPane.addEventListener("mouseenter", function () {
                var tabId = tabPane.getAttribute("id");
                var tabLink = document.getElementById(tabId + "-tab");

                var tabTrigger = new Tab(tabLink);
                tabTrigger.show();
                navDropdown.classList.remove("empty");
            });

            // Close tab when mouse leaves
            tabPane.addEventListener("mouseleave", function () {
                closeTabs();

                var tabId = tabPane.getAttribute("id");
                var tabLink = document.getElementById(tabId + "-tab");

                // Remove stuff from tab link
                tabLink.classList.remove("active");
                tabLink.setAttribute("aria-selected", "false");
            });
        });
    }

    /*
    document.querySelectorAll(".main-nav-tabs a").forEach(function (navItem) {
      // Open relevant tab when mouse enters
      navItem.addEventListener("mouseenter", function () {

        var tabTrigger = new Tab(navItem);

        tabTrigger.show();

        navDropdown.classList.remove("empty");
      });

      // Close tab when mouse leaves
      navItem.addEventListener("mouseleave", function () {
        closeTabs();

        // Remove stuff from tab link
        navItem.classList.remove("active");
        navItem.setAttribute("aria-selected", "false");
      });

      // Click takes you to the relevant page
      navItem.addEventListener("click", function () {
        var navUrl = navItem.getAttribute("href");
        window.location.href = navUrl;
      });
    });

    document.querySelectorAll(".main-nav-pane").forEach(function (tabPane) {
      // Keep tab open when mouse enters
      tabPane.addEventListener("mouseenter", function () {
        var tabId = tabPane.getAttribute("id");
        var tabLink = document.getElementById(tabId + "-tab");

        var tabTrigger = new Tab(tabLink);
        tabTrigger.show();
        navDropdown.classList.remove("empty");
      });

      // Close tab when mouse leaves
      tabPane.addEventListener("mouseleave", function () {
        closeTabs();

        var tabId = tabPane.getAttribute("id");
        var tabLink = document.getElementById(tabId + "-tab");

        // Remove stuff from tab link
        tabLink.classList.remove("active");
        tabLink.setAttribute("aria-selected", "false");
      });
    });

    */

    // Allow for navigation without breaking accessibility 
    document.querySelectorAll('.dd-tab-link').forEach(link => {
        link.addEventListener('click', e => {
            window.location.href = link.getAttribute('data-href');
        });
    });    


    // Project tab
    var projectsTab = document.getElementById("projects-nav-tab");

    projectsTab.addEventListener('shown.bs.tab', event => {

        // Ensure shave works on project title
        shave("#projects-nav .project-item-title", 100, {});

        // Calculate project content height
        var menuProjectItem = document.querySelector("#projects-nav .project-item");
        var contentHeight = document.querySelector('#projects-nav .project-item-content').offsetHeight + "px";
        menuProjectItem.style.setProperty('--content-height', contentHeight);

        // Adds slight delay before changing transition time
        setTimeout(() => {
          menuProjectItem.style.setProperty('--transition-time', "1s");
        }, 200);

    })

    // Add nice scrollbars to menu when needed
    OverlayScrollbars(document.querySelector(".main-nav-wrapper"), {
        overflow: {
        x: "hidden",
        },
        scrollbars: {
        visibility: "auto",
        autoHide: "leave",
        },
    });
});